var version = {
    "name":      "dativery",
    "buildDateCode": "20261009-080521",
    "buildDate": "Fri Oct 09 2026 08:05:21 GMT+0000 (Coordinated Universal Time)",
    "version":   "2.2.0",
    "uiVersion": "2.2.0-20261009-080521",
    "backupUIVersion": "2.2.0-20250519-102244"
}
;
 export default version;